import PropTypes from "prop-types";
import { ReactComponent as CloseIcon } from "../../../../assets/img/icon/close_black_24dp.svg";

const Toast = (props) => {
  const handleClose = () => {
    if (props.handleClose) props.handleClose();
  };

  let toastStyle = props.show
    ? {
        opacity: "1",
        marginTop: "2rem",
        height: "auto",
      }
    : {
        opacity: "0",
        marginTop: "0",
        height: "0",
      };

  return (
    <div className="fixed h-2 z-40 top-10 left-0 right-0 ">
      <div className="xl:container h-0 mx-auto px-4">
        <div
          className=" bg-white border  max-w-md mx-auto sm:mr-0 mt-10 rounded-xl shadow-lg relative transition-all duration-300 ease-in-out overflow-hidden"
          style={toastStyle}
        >
          <div className="bg-gray-500 text-white px-3 py-2 border-b relative">
            <div className="flex items-center space-x-2">
              <div className="w-5 h-5 rounded bg-white" />
              <div className="font-semibold">Respinos</div>
            </div>
            <div
              className="absolute right-2 top-2.5 cursor-pointer"
              onClick={handleClose}
            >
              <CloseIcon className="fill-current text-white h-5 w-5" />
            </div>
          </div>
          <div className="px-3 py-2">{props.message}</div>
        </div>
      </div>
    </div>
  );
};

Toast.propsTypes = {
  message: PropTypes.node.isRequired,
  handleClose: PropTypes.func.isRequired,
  sho: PropTypes.bool.isRequired,
};

export default Toast;
